// @flow

import React, {Component} from 'react';
import classnames from 'classnames';
import {SORTABLE_FILTER} from './constants';
import type {Node} from 'react';

type Props = {|
    itemId: string,
    isPlaceholder: boolean,
    children: Node,
    mix: string,
|};

export class SortableItem extends Component<Props> {
    static defaultProps = {
        isPlaceholder: false,
        mix: ''
    };
    render() {
        const {itemId, isPlaceholder, mix} = this.props;
        const classes = classnames('sortable__item', {
            sortable__item_placeholder: isPlaceholder,
            [SORTABLE_FILTER]: isPlaceholder,
            [mix]: mix
        });
        return (
            <div data-id={itemId} className={classes}>
                {this.props.children}
            </div>
        );
    }
}
